<!-- instructions at the bottom of the component -->
<template lang="html">
  <v-dialog
    v-if="getDialog"
    :value="getDialog"
    :persistent="
      getDialog.hasOwnProperty('persistent') ? getDialog.persistent : true
    "
    :max-width="
      getDialog.hasOwnProperty('maxWidth') ? getDialog.maxWidth : '500'
    "
  >
    <v-card>
      <!-- toolbar (header) and title -->
      <v-toolbar
        v-if="getDialog.hasOwnProperty('header') ? getDialog.header : false"
        flat
        color="primary"
        dark
      >
        <v-card-title
          v-html="getDialog && getDialog.title ? getDialog.title : ''"
          class="text-h5 pa-0 fix font-weight-medium"
        ></v-card-title>
      </v-toolbar>
      <v-card-title
        v-else
        v-html="getDialog && getDialog.title ? getDialog.title : ''"
        class="pl-4 text-h5 fix"
      ></v-card-title>
      <!-- subtitle -->
      <v-card-subtitle
        v-if="getDialog.subtitle"
        v-html="getDialog.subtitle"
        class="subtitle pl-4 pt-4 pb-0"
      ></v-card-subtitle>
      <!-- text -->
      <v-card-text v-if="getDialog.text" class="mb-10 pl-4 pt-5">{{
        getDialog && getDialog.text ? getDialog.text : ''
      }}</v-card-text>
      <!-- actions -->
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="darken-1" @click="save()" v-if="getDialog.saveText">
          {{ getDialog.saveText }}
        </v-btn>
        <v-btn color="darken-1" @click="cancel()" v-if="getDialog.cancelText">
          {{ getDialog.cancelText }}
        </v-btn>
        <v-btn color="primary darken-1" @click="ok()" v-if="getDialog.okText">
          {{ getDialog.okText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DialogWrapper',
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapGetters('DialogStore', ['getDialog'])
  },
  methods: {
    save() {
      this.$store.dispatch('DialogStore/save')
    },
    cancel() {
      this.$store.dispatch('DialogStore/cancel')
    },
    ok() {
      this.$store.dispatch('DialogStore/ok')
    }
  }
}
</script>

<style lang="scss" scoped>
.fix {
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: normal;
}
.subtitle {
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
  color: white !important;
}
</style>

<!--
Instructions:
to open dialog call: dispatch('DialogStore/open', and pass object with dialog properties.
dialog properties:
 - title
 - header - header section with background, title goes inside.
 - subtitle
 - text
 - okText - text for ok btn - if not defined, btn will be hidden
 - cancelText - text for cancel btn - if not defined, btn will be hidden
 - ok - function that will be called once ok is clicked
 - cancel - function that will be called once cancel is clicked
 - persistent - default true (dont close dialog on click outside)
 - maxWidth - max-width of the dialog - default 500px

Aditional features can be added :D
If you are changing something write it here.

example:
this.$store.dispatch('DialogStore/open', {
  title: 'You did not save the data!',
  text: 'All changes will be lost!',
  okText: 'Stay',
  ok: () => {
    next(false)
  },
  cancelText: 'Discard and leave',
  cancel: () => {
    localStorage.exploreProjectActiveTab = 'details'
    next()
  }
})
 -->
